// extracted by mini-css-extract-plugin
module.exports = {"root":"EnquiryPanel_root__3_QmT","heading":"EnquiryPanel_heading__20gqM","contactForm":"EnquiryPanel_contactForm__3Sa9x"};